const state = {
  dadosFechamento: Array
}

const mutations = {
  setDadosFechamento (state, obj) {
    state.dadosFechamento = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/fechamentoExtra.js